import { BaseMapInfoWindowBuilder } from '../../../../_shared/interfaces/maps/base-map-info-window-builder';

export class WorkshopMapInfoWindowBuilder extends BaseMapInfoWindowBuilder {
  override buildMapInfoWindowHTML(data: any): string {
    const name = this.escapeHTML(data.name);
    const workshopType = this.escapeHTML(data.workshopType);
    const phoneNumber = this.escapeHTML(data.phoneNumber);
    const email = this.escapeHTML(data.email);
    const location = this.escapeHTML(data.address);

    return `
      <div class="ws-iw">
        <style>
          .gm-style-iw-ch {
            padding: 0 !important;
          }

          .gm-style-iw-d {
            max-height: none !important;
            overflow: visible !important;
            overflow-x: hidden !important;
          }

          .gm-style-iw, .gm-style-iw-c {
            max-width: none !important;
            overflow: visible !important;
            padding: 16px !important;
            width: 280px !important;
            height: auto !important;
            max-height: none !important;
          }

          .ws-iw .rows {
            display: grid;
            grid-template-columns: auto 1fr;
            column-gap: 12px;
            row-gap: 8px;
            align-items: start;
            font-size: 14px;
          }

          .ws-iw .label {
            color: #9FA1A4;
            font-weight: 400;
            white-space: nowrap;
          }

          .ws-iw .val {
            color: #4D4749;
            overflow-wrap: anywhere;
            line-height: 1.25;
          }
        </style>

        <div class="rows">
          <div class="label">Name:</div>           <div class="val">${name}</div>
          <div class="label">Type:</div>            <div class="val">${workshopType}</div>
          <div class="label">Phone:</div>           <div class="val">${phoneNumber}</div>
          <div class="label">Email:</div>           <div class="val">${email}</div>
          <div class="label">Location:</div>        <div class="val">${location}</div>
        </div>
      </div>
    `;
  }
}